export const HOURS_IN_DAY = 24;
export const MINUTES_IN_HOUR = 60;
export const MINUTES_IN_DAY = MINUTES_IN_HOUR * HOURS_IN_DAY;
export const SECONDS_IN_MINUTE = 60;
